import React, {useState} from 'react';
import "../style/user_and_patient_form.scss";
import InputField from "../commons/InputField";
import {emptyPatientWithUserInfo, PatientWithUserInfo} from "../models/Patient";
import {googleServer} from "../commons/commonVariable";
import {useNavigate} from "react-router-dom";
import TopBar from "../commons/TopBar";


const UserAndPatientForm = () => {
    const [formData, setFormData] = useState<PatientWithUserInfo>(emptyPatientWithUserInfo);
    const [isLoading, setIsLoading] = useState<boolean>();
    const navigate = useNavigate();
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    }
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsLoading(true);
        const [patientResponse] = await Promise.all([
            await fetch(googleServer + '/savePatientInfo', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formData),
                credentials: "include"
            }),
            await fetch(googleServer + '/user/updateUser', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    institution: formData.institution,
                    department: formData.department
                }),
                credentials: "include"
            })
        ])
        setIsLoading(false);
        if (patientResponse.status === 201) {
            navigate("/welcome");
        }
    }

    return (
        <React.Fragment>
            <TopBar showGoogleSignIn={false} />
            <div style={{marginTop: '120px'}}>
                <link rel="preconnect" href="https://fonts.googleapis.com"/>
                <h2 style={{marginBottom: 0, fontWeight: 700, fontSize: '2rem'}}>Almost Done! Just a Few More Details</h2>
                <div style={{color: '#6b7280', fontSize: '1.4rem', marginBottom: '1.5rem'}}>Please complete the form below to continue</div>
                <form className="user-and-patient-form-container" onSubmit={handleSubmit}>
                    <div className="sub-form-box">
                        <span className="form-header">Your Information</span>
                        <span className="form-divider"></span>
                        <InputField
                            label="Institution"
                            type="text"
                            name="institution"
                            placeholder="Type your institution"
                            onChange={handleChange}
                            required={false}
                            autoFocus={true}
                            className={"form-input"}
                            value={formData.institution}
                        />
                        <InputField
                            label="Department"
                            type="text"
                            name="department"
                            placeholder="Type your department"
                            onChange={handleChange}
                            required={false}
                            className={"form-input"}
                            value={formData.department}
                        />
                    </div>
                    <div className="sub-form-box">
                        <span className="form-header">Patient Information</span>
                        <span className="form-divider"></span>
                        <InputField
                            label="First Name"
                            type="text"
                            name="firstName"
                            placeholder="First Name"
                            onChange={handleChange}
                            required={true}
                            className={"form-input"}
                            value={formData.firstName}
                        />
                        <InputField
                            label="Last Name"
                            type="text"
                            name="lastName"
                            placeholder="Last Name"
                            onChange={handleChange}
                            required={true}
                            className={"form-input"}
                            value={formData.lastName}
                        />
                        <InputField
                            label="Sex"
                            type="radio"
                            name="sex"
                            onChange={handleChange}
                            required={true}
                            className="radio-option"
                            options={[
                                {label: "Male", value: "male"},
                                {label: "Female", value: "female"}
                            ]}
                            value={formData.sex}
                        />
                        <InputField
                            label="Date of Birth"
                            type="date"
                            name="birthday"
                            placeholder="Date of Birth"
                            onChange={handleChange}
                            required={true}
                            className={"form-input"}
                            value={formData.birthday}
                        />
                        <InputField
                            label="Chief Complain"
                            type="text"
                            name="chiefComplain"
                            placeholder="Chief Complain"
                            onChange={handleChange}
                            required={true}
                            className={"form-input"}
                            value={formData.chiefComplain}
                        />
                        <InputField
                            label="Allergy"
                            type="text"
                            name="allergy"
                            placeholder="Allergy"
                            onChange={handleChange}
                            required={true}
                            className={"form-input"}
                            value={formData.allergy}
                        />
                        <InputField
                            label="Primary Care Provider"
                            type="text"
                            name="primaryCareProvider"
                            placeholder="Primary Care Provider"
                            onChange={handleChange}
                            required={true}
                            className={"form-input"}
                            value={formData.primaryCareProvider}
                        />
                        {isLoading ? (<div className="spinner-user-and-patient-form"></div>) : (
                            <button type="submit" className="form-button" value="Submit">
                                Submit
                            </button>)
                        }
                    </div>
                </form>
            </div>
        </React.Fragment>
    );
}

export default UserAndPatientForm;